import { Loader } from "@components/Loader";
import { MainLayout, MainLayoutProps } from "@components/MainLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { usePastTransactions, usePendingTransactions, useUpcomingTransactions } from "@hooks";
import { Translations, i18n } from "@i18n";
import { Past, Pending, Upcoming } from "./icons";
import { PastTransfers } from "./PastTransfers";
import { PendingTransfers } from "./PendingTransfers";
import { CaptionText } from "./styles";
import { TransferGroup } from "./TransfersGroup";
import { UpcomingTransfers } from "./UpcomingTransfers";

export const TransfersRoute = () => {
  const { loading: pastLoading } = usePastTransactions();
  const { loading: upcomingLoading } = useUpcomingTransactions();
  const { loading: pendingLoading } = usePendingTransactions();

  const loading = pastLoading || upcomingLoading || pendingLoading;

  const props: MainLayoutProps = {
    showTab: true,
  };

  if (loading) {
    return (
      <MainLayout {...props} loader>
        <Loader />
      </MainLayout>
    );
  }

  return (
    <MainLayout {...props}>
      <CaptionText>{i18n.t(Translations.TransfersRouteTitle)}</CaptionText>
      <Spacing size={SpacingSizes.XL} />

      <TransferGroup icon={<Upcoming />} title={i18n.t(Translations.TransfersRouteUpcomingLabel)}>
        <UpcomingTransfers />
      </TransferGroup>
      <Spacing size={SpacingSizes.XL} />

      <TransferGroup icon={<Pending />} title={i18n.t(Translations.TransfersRoutePendingLabel)}>
        <PendingTransfers />
      </TransferGroup>
      <Spacing size={SpacingSizes.XL} />

      <TransferGroup icon={<Past />} title={i18n.t(Translations.TransfersRoutePastLabel)} expanded>
        <PastTransfers />
      </TransferGroup>
      <Spacing size={SpacingSizes.XL} />
    </MainLayout>
  );
};
